import { KeyValueModel } from "model/api";

export const ModNFP: KeyValueModel[] = [
    new KeyValueModel(2, "Nota Fiscal de Produtor"),
    new KeyValueModel(1, "Avulsa"),
];
